import { Box, Flex } from '@chakra-ui/react';
import { EarnPerksMessage } from '../../../../components/earn-perks-message';
import { PerksIcon } from '../../../../components/icons';
import { usePDP } from '../../../../contexts/pdp/usePDP';

export const ProductPerks: React.FC = () => {
    const { product, selectedQuantity } = usePDP();

    if (
        !product ||
        !window.rewardsMessaging ||
        (window.rewardsMessaging !== 'PDP' && window.rewardsMessaging !== 'PDP&CART')
    ) {
        return null;
    }

    const price = (product.price ?? 0) * selectedQuantity;

    return (
        <Flex
            data-testid="buy-box-perks"
            alignItems="center"
            marginLeft={4}
            borderColor="slt-pepper.300"
            borderRadius={4}
            borderWidth={1}
            paddingLeft={8}
            height="68px"
            position="relative"
        >
            <Box
                background="slt-beige.400"
                borderRadius={24}
                position="absolute"
                left={-6}
                padding={2}
            >
                <PerksIcon data-testid="buy-box-perks-icon" color="slt-primary-green.1000" />
            </Box>

            <EarnPerksMessage id="buy-box-perks" price={price} />
        </Flex>
    );
};
